import workspacesApi from '@innovyze/stylovyze/lib/apis/workspace.api';
export const getWorkspaces = (params) => {
    return workspacesApi.get('workspaces', {
        params: params,
    });
};
export const getWorkspaceById = (id) => {
    return workspacesApi.get(`workspace/${id}`);
};
export const putWorkspace = (workspace) => {
    return workspacesApi.put(`/workspace/${workspace.id}`, workspace);
};
